import {
  TConvertedProductInfo,
  toCartDomesticOrder,
  toReceiptDomestic,
} from './converter/DomesticOrderConverter'
import {
  toCartLeisureOrder,
  toLeisureOrder,
  toReceiptLeisure,
} from './converter/LeisureOrderConverter'
import { toCartTrainOrder, toTrainOrder, toReceiptTrain } from './converter/TrainOrderConverter'
import { CANCELLATION_STATUS, SERVICE_TYPE, STATUS } from '~/app/utils/OrderListUtils'
import { ReactElement } from 'react'
import { toBusOrder, toCartBusOrder, toReceiptBus } from './converter/BusOrderConverter'
import {
  CategoryType,
  DomesticDailyPrices,
  LeisureCancellationFeePlan,
  PropertyCategory,
} from '~/__generated__/__types__'
import { CancelPolicySummary, LeisureProductDetailInfo } from '~/__generated__/__types__'
import { TCommonVipBadgeType } from '~/api/converters/global/common/VipDiscountBadge/index.type'
import { TMemberClassBadge } from '~/api/services/member-class-api/index.type'
import { OrderButton } from './types'

export type ConvertedOrder = {
  id: string
  categoryOrderId?: string
  status?: STATUS | CANCELLATION_STATUS
  serviceType?: SERVICE_TYPE
  categoryType?: CategoryType
  title: string
  subTitle: string
  ratePlanTitle?: string
  secondarySubTitle?: string
  secondaryInfo?: string[][]
  imageSrc?: string | ReactElement
  info?: TConvertedProductInfo
  options?: string
  buttons?: OrderButton[]
  promotion?: string
  price?: number
  promotions?: string[] // 숙박대전
  badges?: string[]
  banners?: string[]
  isInfiniteCouponRoom?: boolean // 무한 쿠폰 룸
  pdpUrl?: string
  deeplink?: string
  busTransportationCompanyCode?: string // 고속버스 로고 없는 경우 운수사 이름 노출 조회 용
  stationTrainClassifyCode?: string // 기차 code for 로고
  useEndDate?: string
  useTypeText?: string // 국내 숙소 숙박 형태(대실, 숙박)
  cancelPolicySummary?: CancelPolicySummary
  hasPenalty?: boolean
  hasPartialCancel?: boolean // datasource 는 required 이지만, 예약내역 상세에서만 쓰이기 때문에 prop 상에서는 optional로 선언한다
  isPendingReservation?: boolean // 국내 숙소 대기 예약 상태 여부
  isExceptionalCancelPolicy?: boolean // 호텔 무료취소 예외 규정 정책 연동 여부
  isRefundableAfterExpiration?: boolean // 레저 > 만료 후 환불 가능 여부
  validityEndDateTime?: string // 레저 > 유효기간 종료일시
  refundInfo?: LeisureProductDetailInfo[] // 레저 > 취소/환불 규정
  isShowLeisureCancelRequestNotice?: boolean // 레저 > 취소 완료 안내 문구 노출 여부
  propertyCategory?: PropertyCategory // 숙소 > 숙소 카테고리
  vipMemberClassBadgeType?: TCommonVipBadgeType | '' // 숙소 > vip 적용 등급제 뱃지 타입. UI에서는 미사용, 예약확인서 이메일 템플릿(vipMemberClass)에서만 소비
  memberClassBadge?: TMemberClassBadge // 주문 상세 > 등급 특가 뱃지 (displayBadge)
  optionTitle?: { title: string; caption?: string } // 레저 > 옵션명
  cancellationFeePlans?: LeisureCancellationFeePlan[]
  isAPIFailed?: boolean
  dailyPrices?: DomesticDailyPrices[] // 숙소 > 일자별 요금 (연박 상세요금)
}
/** 레저 API 응답 실패시 노출되는 최소한의 주문 정보 */
export type ConvertedAPIFailedLeisureOrder = Pick<
  ConvertedOrder,
  'categoryOrderId' | 'categoryType' | 'title' | 'imageSrc' | 'isAPIFailed'
>
const getCartOrderConverter = () => {
  return {
    toCartDomesticOrder,
    toReceiptDomestic,
    toCartLeisureOrder,
    toLeisureOrder,
    toReceiptLeisure,
    toCartTrainOrder,
    toTrainOrder,
    toReceiptTrain,
    toCartBusOrder,
    toBusOrder,
    toReceiptBus,
  }
}

export default getCartOrderConverter
